import React from 'react'
import { Gashapon as GashaponComponent } from "../../../Components/Player/Gashapon"
import { Flex } from 'antd'
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

export const Gashapon = () => {
  const navigate = useNavigate();
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });

  return (
    <Flex justify='center' align='center'>
      {
        isDesktopOrLaptop ? navigate("/404") : <GashaponComponent />
      }
    </Flex>
  )
}
